import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { OutreachAutomationFlowEntity } from './outreach-automation-flow.entity';
import { OutreachCampaignAudienceEntity } from './outreach-campaign-audience.entity';
import { OutreachSendEntity } from './outreach-send.entity';

@Entity('_outreach_campaign')
export class OutreachCampaignEntity extends BaseEntity {
	@Column('varchar', { name: '_name', length: 255 })
	public name!: string;

	@Column('enum', { name: '_campaign_type', enum: ['email', 'phone'] })
	public campaignType!: 'email' | 'phone';

	@Column('varchar', { name: '_subject', nullable: true, length: 255 })
	public subject!: string | null;

	@Column('varchar', { name: '_from_email', nullable: true, length: 255 })
	public fromEmail!: string | null;

	@Column('varchar', { name: '_from_name', nullable: true, length: 255 })
	public fromName!: string | null;

	@Column('varchar', { name: '_from_phone', nullable: true, length: 20 })
	public fromPhone!: string | null;

	@Column('enum', {
		name: '_status',
		enum: ['draft', 'scheduled', 'sending', 'sent', 'paused', 'cancelled'],
	})
	public status!:
		| 'draft'
		| 'scheduled'
		| 'sending'
		| 'sent'
		| 'paused'
		| 'cancelled';

	@Column('timestamp', { name: '_scheduled_send_date', nullable: true })
	public scheduledSendDate!: Date | null;

	@Column('timestamp', { name: '_send_started_date', nullable: true })
	public sendStartedDate!: Date | null;

	@Column('timestamp', { name: '_send_completed_date', nullable: true })
	public sendCompletedDate!: Date | null;

	@Column('json', { name: '_settings', nullable: true })
	public settings!: object | null;

	@Column('text', { name: '_description', nullable: true })
	public description!: string | null;

	@Column('int', {
		name: '_fk__automation_flow__id',
		nullable: true,
		unsigned: true,
	})
	public fkAutomationFlowId!: number | null;

	@OneToMany(
		() => OutreachAutomationFlowEntity,
		(outreachAutomationFlow) => outreachAutomationFlow.fkOutreachCampaign,
		{},
	)
	public outreachAutomationFlows!: Array<OutreachAutomationFlowEntity>;

	@OneToMany(
		() => OutreachCampaignAudienceEntity,
		(outreachCampaignAudience) => outreachCampaignAudience.fkOutreachCampaign,
		{},
	)
	public outreachCampaignAudiences!: Array<OutreachCampaignAudienceEntity>;

	@OneToMany(
		() => OutreachSendEntity,
		(outreachSend) => outreachSend.fkOutreachCampaign,
		{},
	)
	public outreachSends!: Array<OutreachSendEntity>;
}
